module.exports = __webpack_public_path__ + "frontend/images/green/carousel/static/2@2.png?55189a9fcf5ade9c93d0ab5aa939f77e";